<template>

<div class="nextsteps" v-if="actions.length">

	<div class="nextsteps-title">Next Steps</div>

	<div class="nextsteps-subtitle">Which of the following would you like to do?</div>

	<div class="nextsteps-actions">

		<button class="nextsteps-action" v-for="action in visibleActions" :key="action.id" v-on:click="$emit('action', action)">

			<div class="nextsteps-action-icon is-completed" v-if="isCompleted(action.id)"><i class="fa-solid fa-check"></i></div>

			<div class="nextsteps-action-icon" v-else-if="action.icon"><i :class="action.icon"></i></div>

			<div class="nextsteps-action-body">

				<div class="nextsteps-action-text">{{ action.text }}</div>

				<div class="nextsteps-action-description" v-if="action.description" v-html="action.description"></div>

			</div>

			<div class="nextsteps-action-chevron"></div>

		</button>

	</div>

</div>

</template>

<script>

export default {

	props: ['recommendation'],

	computed: {

		actions: function() {

			return this.$store.getters['data/bridge/actions']

		},

		visibleActions: function() {

			return this.$_.filter(this.actions, function(action) {

				return this.visible(action)

			}.bind(this))

		}

	},

	methods: {

		isCompleted: function(id) {

			return this.$_.contains(this.$store.getters['session/bridge/completed'], id)

		},

		visible: function(action) {

			if (action.visibility.enabled === this.$constants.visibility.always) {

				return true

			} else if (action.visibility.enabled === this.$constants.visibility.sometimes) {

				return this.$store.getters['logic/evaluate'](action.visibility.logic)

			}

			return true

		}

	}

}

</script>

<style scoped>

.nextsteps {
	margin-top: 24px;
}

.nextsteps-title {
	font-weight: 100;
	font-size: 24px;
	line-height: 26px;
	letter-spacing: 2px;
	color: #343434;
	text-transform: uppercase;
	margin-bottom: 8px;
}

.is-mobile .nextsteps-title {
	font-size: 18px;
	line-height: 18px;
}

.nextsteps-subtitle {
	font-size: 16px;
	color: #666;
	margin-bottom: 16px;
	line-height: 24px;
}

.nextsteps-actions {
	display: flex;
	flex-direction: column;
}

.nextsteps-action {
	display: flex;
	flex-direction: row;
	align-items: flex-start;
	padding: 16px 20px;
	background-color: transparent;
	border: none;
	border-bottom: 1px solid #e0e0e0;
	cursor: pointer;
	text-align: left;
	transition: all 300ms ease-in-out;
}

.nextsteps-action:first-child {
	border-top: 1px solid #e0e0e0;
}

.nextsteps-action:hover {
	background-color: #f8f8f8;
}

.nextsteps-action:hover .nextsteps-action-chevron {
	border-color: var(--primary-color);
}

.nextsteps-action-icon {
	width: 40px;
	height: 40px;
	flex-shrink: 0;
	margin-right: 16px;
	margin-top: 2px;
	border-radius: 50%;
	background-color: #343434;
	display: flex;
	align-items: center;
	justify-content: center;
	transition: all 300ms ease-in-out;
}

.nextsteps-action:hover .nextsteps-action-icon:not(.is-completed) {
	background-color: var(--primary-color);
}

.nextsteps-action-icon.is-completed {
	background-color: #4CAF50;
}

.nextsteps-action-icon i {
	color: #fff;
	font-size: 16px;
	width: 20px;
	text-align: center;
}

.is-mobile .nextsteps-action-icon {
	width: 36px;
	height: 36px;
	margin-right: 12px;
}

.is-mobile .nextsteps-action-icon i {
	font-size: 14px;
}

.nextsteps-action-body {
	flex: 1;
	min-width: 0;
}

.nextsteps-action-text {
	font-size: 16px;
	font-weight: 600;
	color: #343434;
	line-height: 22px;
}

.is-mobile .nextsteps-action-text {
	font-size: 14px;
	line-height: 20px;
}

.nextsteps-action-description {
	font-size: 15px;
	color: #888;
	line-height: 22px;
	margin-top: 1px;
}

.nextsteps-action-description >>> p {
	margin: 0;
}

.is-mobile .nextsteps-action-description {
	font-size: 14px;
	line-height: 20px;
}

.nextsteps-action-chevron {
	width: 10px;
	height: 10px;
	flex-shrink: 0;
	margin-left: 16px;
	align-self: center;
	border-right: 2px solid #ccc;
	border-bottom: 2px solid #ccc;
	transform: rotate(-45deg);
	transition: all 300ms ease-in-out;
}

.is-mobile .nextsteps-action {
	padding: 14px 16px;
}

</style>
